import React from 'react';
import { MOOD_OPTIONS } from '../../constants/moods';

function MoodFilter({ filterMood, filterOpen, onToggle, onSelect }) {
  const selectedOption = MOOD_OPTIONS.find(opt => opt.value === filterMood) || MOOD_OPTIONS[0];

  return (
    <div className="dashboard__filter">
      <button 
        className="dashboard__filter-btn"
        onClick={onToggle}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
        </svg>
        <span className="dashboard__filter-current">
          <span className="dashboard__filter-icon">{selectedOption.icon}</span>
          <span className="dashboard__filter-label">{selectedOption.label}</span>
        </span>
        <svg 
          className={`dashboard__filter-arrow ${filterOpen ? 'dashboard__filter-arrow--open' : ''}`}
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M6 9l6 6 6-6"/>
        </svg>
      </button>

      {filterOpen && (
        <>
          <div 
            className="dashboard__filter-overlay"
            onClick={onToggle}
          />
          <div className="dashboard__filter-dropdown">
            {MOOD_OPTIONS.map((option) => (
              <button
                key={option.value}
                className={`dashboard__filter-option ${option.value === filterMood ? 'dashboard__filter-option--active' : ''}`}
                onClick={() => onSelect(option.value)}
              >
                <span className="dashboard__filter-option-icon">{option.icon}</span>
                <span className="dashboard__filter-option-label">{option.label}</span>
                {option.value === filterMood && (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default MoodFilter;
